import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Avatar, Card, CardContent, CardHeader, CardMedia, Typography } from '@mui/material';
import dk from '../../assets/dk.svg';
import gb from '../../assets/gb.svg';
import de from '../../assets/de.svg';
import certificate from '../../assets/alllogosBig.png';

const styles = {
    arsContainer: {
        maxWidth: 1200,
        margin: '0 auto',
        padding: 40
    },
};

export default function AppFooter() {
    return (
        <Box sx={{ flexGrow: 1, backgroundColor: '#fff' }}>
            <Box style={styles.arsContainer}>
                <Grid container padding={4} spacing={{ xs: 2, md: 3 }} columns={{ xs: 12, sm: 12, md: 12 }}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card sx={{ maxWidth: 400, height: '100%', backgroundColor: 'inherit' }} elevation={0}>
                            <CardHeader
                                avatar={
                                    <Avatar variant="square" alt='Denmark' src={dk} />
                                }
                            />
                            <CardContent>
                                <Typography variant="h6" color="text.secondary">
                                    <strong> Tier1 Asset A/S</strong>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Hejrevang 18 <br />
                                    3450 Allerod <br />
                                    Denmark
                                </Typography>
                                <p><a href="tel:+4570250760">+45 70250760</a></p>
                                <Typography variant="h6" color="text.secondary">
                                    <strong>Office hours:</strong>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    <em>Weekdays: 08:00-1600 GMT+1 </em>
                                </Typography>
                                <Typography variant="h6" color="text.secondary">
                                    <strong> Warehouse hours:</strong>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    <em>Weekdays: 08:00-1600 GMT+1</em>
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card sx={{ maxWidth: 400, height: '100%', backgroundColor: 'inherit' }} elevation={0}>
                            <CardHeader
                                avatar={
                                    <Avatar variant="square" alt='England' src={gb} />
                                }
                            />
                            <CardContent>
                                <Typography variant="h6" color="text.secondary">
                                    <strong> T1A Ltd</strong>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Centurion House <br />
                                    London Road <br />
                                    Staines-upon-Thames<br />
                                    TW18 4AX<br />
                                    United Kingdom
                                </Typography>
                                <br />
                                <p><a href="tel:+441908538500">+44 (0) 1908538500</a></p>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card sx={{ maxWidth: 400, height: '100%', backgroundColor: 'inherit' }} elevation={0}>
                            <CardHeader
                                avatar={
                                    <Avatar variant="square" alt='Deutschland' src={de} />
                                }
                            />
                            <CardContent>
                                <Typography variant="h6" color="text.secondary">
                                    <strong>Tier1Asset Deutschland</strong>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Zweigniederlassung der <br />
                                    Tier1Asset A/S <br />
                                    Daimlerring 4<br />
                                    65205 Wiesbaden<br />
                                    Germany
                                </Typography>
                                <br />
                                <Typography variant="body2" color="text.secondary">
                                    General Manager <br />
                                    Hakan Budak
                                </Typography>
                                 <p><a href="tel:+49611 97 86 92 00">+49 (0) 611 97 86 92 00</a></p>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card sx={{ maxWidth: 400, height: '100%', backgroundColor: 'inherit' }} elevation={0}>
                            <CardHeader                                
                                title={<Typography variant="h6">
                                    <strong>Certificates</strong>
                                </Typography>}
                            />
                            <CardMedia
                                component="img"
                                image={certificate}
                                alt="certificates"
                                style={{backgroundColor: '#003755' }}
                            />
                        </Card>
                    </Grid>

                </Grid>
            </Box>
        </Box >
    );
}